import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { regionsRepository } from '@/Infrastructure/State/Slices/RegionSlice/RegionSlice';
import { getCookie } from '@/modules/perseo-billing/hooks';
import { useDeviceParam } from '@/modules/perseo-billing/hooks/use-device-params';
import BuyNowHeader from '@/Pages/MainLayout/partials/Header/BuyNowHeader';
import RegionProvider from '@/sections/region/RegionContext';

const BuyNowLayout = () => {
  useDeviceParam();

  useEffect(() => {
    const tokenUserID = getCookie('tokenUserId');
    window.cnstrcUserId = tokenUserID;
  }, []);

  return (
    <RegionProvider repository={regionsRepository}>
      <div className="co-flex co-flex-col">
        <BuyNowHeader />
        <div className="co-flex co-flex-1 co-justify-center co-px-0 tablet_w:co-px-[32px] co-pt-4 tablet_w:co-pt-[32px]">
          <Outlet />
        </div>
      </div>
    </RegionProvider>
  );
};

BuyNowLayout.displayName = 'BuyNowLayout';

export default BuyNowLayout;
